import type { AxiosError, AxiosRequestConfig } from 'axios';
import type { IsAny, IsNever, IsUnknown } from 'type-fest';

import { apiClient } from '@/utils/api-client';
import type { HTTPError } from '@/utils/http-client';

/**
 * Custom client instance for Orval-generated API hooks.
 */
export async function apiInstance<T, D = unknown>(
  { url, ...config }: AxiosRequestConfig<D>,
  extendedConfig?: AxiosRequestConfig<D>,
): Promise<T> {
  const client = await apiClient();

  if (!url) throw new Error('URL is required');

  return client.request<T, D, false>(url, { ...config, ...extendedConfig });
}

export type ErrorType<E> =
  | (IsNever<E> extends true ? never : IsUnknown<E> extends true ? never : IsAny<E> extends true ? never : E)
  | HTTPError
  | Error
  | AxiosError;

export type BodyType<BodyData> = BodyData;
